import { getRecommendations } from "../../apis";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import XMLParser from 'react-xml-parser';
import { BUSINESS_LAYER_RESPONSE, MULTIPLIER, RECOMMENDATIONS, WATCHLIST_GRID_INDEX } from "../../utils/global_variables"; // Prachi T : 05-12-2023 : BT-107423 - Breeze - Dashboard recommemndations
import { convertScripResponseWatchlistGrid, getMktSegIdFromMappedMktSegId } from "../../utils/global_functions";
import moment from "moment";
import { recommendationTags } from "../../redux/actions/recommendation";

const DATE_FORMAT = { DATE: 'DATE', DATE_TIME: 'DATE_TIME' };

const getISTDate = (string) => {
    const updatedString = string.slice(0, -1);
    return new Date(`${updatedString}+05:30`);
};

const handleTime = (timestamp, dateFormat) => {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    const dateObj = dayjs.tz(timestamp, 'UTC');
    const timeStr = dateObj.format('hh:mm A');
    const dateStr = dateObj.format("DD MMM'YY");
    const newTimestamp = timeStr + ", " + dateStr;

    if (dateFormat === DATE_FORMAT.DATE) {
        return dateStr;
    }
    else {
        return newTimestamp;
    }
};

/**HARI */

async function _getRecommendations(allowedNewsCat, pageNo, pageSize) {
    try {
        const objResp = await getRecommendations(allowedNewsCat, pageNo, pageSize);
        let arrRecommendation = [];
        if (objResp?.data?.result?.length > 0) {
            arrRecommendation = objResp?.data?.result;
        } else {
            arrRecommendation = [];
        }
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: arrRecommendation };
    } catch (error) {
        return { status: true, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: [] };
    }
}

async function _recommendation(allowedNewsCat, pageNo, pageSize, arrWhatsHotData, holdingsScrips) {
    try {
        const { data: arrRecommendationResp } = await _getRecommendations(allowedNewsCat, pageNo, pageSize);
        if (arrRecommendationResp?.length > 0) {
            // Hari-finding the scrips which are having whatsHotData and holdings-start
            //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
            const hotList = new Map();

            arrWhatsHotData?.forEach(({ mktid, token, class: class1, class2, event, date, Desc }) => {
                if (hotList.has(`${mktid}_${token}`)) {
                    const arrHotList = hotList.get(`${mktid}_${token}`);
                    arrHotList.push({ color: class1, bg_color: class2, event, date, Desc });
                    hotList.set(`${mktid}_${token}`, arrHotList);
                } else {
                    hotList.set(`${mktid}_${token}`, [{ color: class1, bg_color: class2, event, date, Desc }]);
                }
            });
            for (let i = 0; i < arrRecommendationResp?.length; i++) {
                arrRecommendationResp[i].nSegmentId = getMktSegIdFromMappedMktSegId(arrRecommendationResp[i].nMarketSegmentId);
                if (i < 10) {
                    if (hotList?.has(arrRecommendationResp[i]?.nSegmentId + '_' + arrRecommendationResp[i]?.nToken)) {
                        arrRecommendationResp[i].dontMiss = [{ event: 'RECO', bg_color: 'default-chip', Desc: 'Recommendation' }, ...hotList?.get(arrRecommendationResp[i]?.nSegmentId + '_' + arrRecommendationResp[i]?.nToken)];
                    } else {
                        arrRecommendationResp[i].dontMiss = [{ event: 'RECO', bg_color: 'default-chip', Desc: 'Recommendation' }];
                    }
                } else {
                    if (hotList?.has(arrRecommendationResp[i]?.nSegmentId + '_' + arrRecommendationResp[i]?.nToken)) {

                        arrRecommendationResp[i].dontMiss = hotList?.get(arrRecommendationResp[i]?.nSegmentId + '_' + arrRecommendationResp[i]?.nToken);
                    } else {
                        arrRecommendationResp[i].dontMiss = [];
                    }
                }
                // Prachi T : 21-11-2023 : BT-107423 - Breeze - Dashboard recommemndations
                const holdings = holdingsScrips?.length && holdingsScrips?.find((hotData) => hotData?.sSymbol?.toString()?.trim() === arrRecommendationResp[i]?.sScripDesc?.trim(" \" ").split(" ")[2]?.toString());
                if (holdings) {
                    arrRecommendationResp[i].isHoldings = true;
                } else {
                    arrRecommendationResp[i].isHoldings = false;
                }
                // Prachi T : 21-11-2023 : BT-107423 - Breeze - Dashboard recommemndations
            }
            //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - End
            // Hari-finding the scrips which are having whatsHotData and holdings-end
            const arrRecommendationTags = [];
            //Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
            const arrRecommendationsStatusTypes = [];
            const arrRecommendationsOrderTypes = [];

            const arrRecommendationData = arrRecommendationResp?.map((each) => {
                const scripDate = !isNaN(Date.parse(each.sScripDesc.split(" ")[each.sScripDesc.split(" ").length - 1])) ? each.sScripDesc.split(" ")[each.sScripDesc.split(" ").length - 1] : "";
                const formattedScripDate = scripDate.length > 0 ? dayjs(scripDate, { format: 'DDMMMYYYY' }).format('DD MMM YYYY') : "";
                const arrXMLRecoDetails = each.sRecoDetails;
                //Breeze : 8190 : Basket Order Recommendation : ManasaB : 23-07-2025 : Parsing XML format into javascript object and avoiding default behaviour of removing white space within field  values - Start
                const sRecoGroupMatches = [...arrXMLRecoDetails.matchAll(/sRecoGroup="([^"]+)"/g)];
                const sRecoGroupValues = sRecoGroupMatches.map(match => match[1]);
                const recoredDetails = new XMLParser({ trimValues: false }).parseFromString(each.sRecoDetails);
                //Breeze : 8190 : Basket Order Recommendation : ManasaB : 23-07-2025  : End
                // Hari k: pooling recommendatins Tags
                if (each?.sRecoTag?.length > 0) {
                    if (!arrRecommendationTags.includes(each?.sRecoTag?.toLowerCase())) {
                        arrRecommendationTags.push(each.sRecoTag?.toLowerCase());
                    }
                } else { }

                let status = RECOMMENDATIONS.STATUS.ACTIVE; //Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
                let sURL = '';

                if (getISTDate(each?.nExpiryDate) < new Date()) {
                    status = RECOMMENDATIONS.STATUS.EXPIRED; //Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
                }

                const modifiledChild = recoredDetails.children.map((eachChild, index) => {
                    let nEnteryPrice = parseFloat(eachChild.attributes.EnteredPrice);
                    let nEntryPercent = parseFloat(((nEnteryPrice * 10) / MULTIPLIER.HUNDRED));
                    let nCalSLPrice = parseFloat(eachChild?.attributes?.SLPrice);
                    let nCalSQPrice = parseFloat((eachChild?.attributes?.SQPrice));
                    let nPostivePercent = 0;
                    let nNegativePercent = 0;
                    let showRecoText = false;
                    const fixedRecoGroup = sRecoGroupValues[index] || '';
                    //To make common URL for recommendation
                    if (eachChild?.attributes?.sURL) {
                        sURL = eachChild?.attributes?.sURL;
                    }

                    //to differentiate recommendation subTypes in BUY and SELL
                    if (eachChild?.attributes?.sSubTypes.search("Long") !== -1) {
                        eachChild.attributes.sSubTypes = eachChild?.attributes?.sSubTypes.replace("Long", "Buy");
                    } else if (eachChild?.attributes?.sSubTypes.search("Short") !== -1) {
                        eachChild.attributes.sSubTypes = eachChild?.attributes?.sSubTypes.replace("Short", "Sell");
                    } else if (eachChild?.attributes?.sSubTypes.search("short") !== -1) {
                        eachChild.attributes.sSubTypes = eachChild?.attributes?.sSubTypes.replace("short", "Sell");
                    }

                    //To mark withdrawn recommendation as expired
                    if (eachChild?.attributes?.sSubTypes.replace(/\s/g, "").toUpperCase() === 'BUYCALL-RECOMMENDATIONWITHDRAWN' || eachChild?.attributes?.sSubTypes.replace(/\s/g, "").toUpperCase() === 'SELLCALL-RECOMMENDATIONWITHDRAWN') {
                        status = RECOMMENDATIONS.STATUS.WITHDRAWN; //Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
                    }

                    //to check if the Reco text should be formatted or a string
                    if (eachChild?.attributes?.sSubTypes && (eachChild?.attributes?.sSubTypes.replace(/\s/g, "").toUpperCase() === 'BUYCALL-SQUAREOFFPARTIAL' || eachChild?.attributes?.sSubTypes.replace(/\s/g, "").toUpperCase() === 'SELLCALL-SQUAREOFFPARTIAL' ||
                        eachChild?.attributes?.sSubTypes.replace(/\s/g, "").toUpperCase() === 'BUYCALL-STOPLOSSTRIGGERED' || eachChild?.attributes?.sSubTypes.replace(/\s/g, "").toUpperCase() === 'SELLCALL-STOPLOSSTRIGGERED' ||
                        eachChild?.attributes?.sSubTypes.replace(/\s/g, "").toUpperCase() === 'BUYCALL-SQUAREOFFTRIGGERED' || eachChild?.attributes?.sSubTypes.replace(/\s/g, "").toUpperCase() === 'SELLCALL-SQUAREOFFTRIGGERED' ||
                        eachChild?.attributes?.sSubTypes.replace(/\s/g, "").toUpperCase().search("ADD") !== -1 ||
                        eachChild?.attributes?.sSubTypes.replace(/\s/g, "").toUpperCase() === 'EXITBUY' || eachChild?.attributes?.sSubTypes.replace(/\s/g, "").toUpperCase() === 'EXITSELL')) {
                        showRecoText = true;
                    } else {
                        showRecoText = false;
                    }

                    //eachChild?.attributes?.nBuySell == 1 => BUY
                    if (eachChild?.attributes?.nBuySell == 1) {
                        if (isNaN(nCalSLPrice) || nCalSLPrice <= 0) {
                            nCalSLPrice = nEnteryPrice - nEntryPercent;
                        }
                        if (isNaN(nCalSQPrice) || nCalSQPrice <= 0) {
                            nCalSQPrice = nEnteryPrice + nEntryPercent;
                        }
                        nNegativePercent = Math.round((((nEnteryPrice - nCalSLPrice) / (nCalSQPrice - nCalSLPrice)) * MULTIPLIER.HUNDRED));
                        nPostivePercent = Math.round((((nCalSQPrice - nEnteryPrice) / (nCalSQPrice - nCalSLPrice)) * MULTIPLIER.HUNDRED));
                    }
                    //eachChild.attributes.nBuySell == 2 => SELL
                    else if (eachChild.attributes.nBuySell == 2) {
                        if (isNaN(nCalSLPrice) || nCalSLPrice <= 0) {
                            nCalSLPrice = nEnteryPrice + nEntryPercent;
                        }
                        if (isNaN(nCalSQPrice) || nCalSQPrice <= 0) {
                            nCalSQPrice = nEnteryPrice - nEntryPercent;
                        }
                        nNegativePercent = Math.round((((nEnteryPrice - nCalSQPrice) / (nCalSLPrice - nCalSQPrice)) * MULTIPLIER.HUNDRED));
                        nPostivePercent = Math.round((((nCalSLPrice - nEnteryPrice) / (nCalSLPrice - nCalSQPrice)) * MULTIPLIER.HUNDRED));
                    }
                    else { }

                    return {
                        nMarketSegmentId: each.nMarketSegmentId,
                        touchLineId: getMktSegIdFromMappedMktSegId(each.nMarketSegmentId) + "_" + each.nToken + each.ID,
                        nSegmentId: getMktSegIdFromMappedMktSegId(each.nMarketSegmentId),
                        nToken: each.nToken,
                        companyName: each.sScripDesc.trim(" \" ").split(" ")[2],
                        exChangeName: each.sScripDesc.trim(" \" ").split(" ")[0],
                        sRecoId: eachChild.attributes.sRecoId,
                        sRecoGroup: fixedRecoGroup,
                        SubTypeID: eachChild.attributes.SubTypeID,
                        sSubTypes: eachChild.attributes.sSubTypes,
                        sFormattedReco: eachChild.attributes.sFormattedReco,
                        dEnteredTime: moment(eachChild.attributes.dEnteredTime, 'MMM D YYYY hh:mmA').format("hh:mm A, DD MMM'YY"),
                        sURL: eachChild.attributes.sURL,
                        EnteredPrice: eachChild.attributes.EnteredPrice,
                        SLPrice: eachChild.attributes.SLPrice,
                        SQPrice: eachChild.attributes.SQPrice,
                        SQPerc: eachChild.attributes.SQPerc,
                        nBuySell: eachChild.attributes.nBuySell == 1 ? 'BUY' : eachChild.attributes.nBuySell == 2 ? 'SELL' : '',
                        OrderCount: eachChild.attributes.OrderCount,
                        dontMiss: each.dontMiss,
                        ltp: 0,
                        nLtpChange: 0,
                        nLtpPercent: 0,
                        calSLPrice: nCalSLPrice,
                        calSQPrice: nCalSQPrice,
                        sLongShort: eachChild.attributes.sLongShort === "L" ? "Long Term" : "Short Term",
                        negativePercent: nNegativePercent,
                        positivePercent: nPostivePercent,
                        showRecoText: showRecoText
                    };
                });
                const rmdMatchingWithParent = recoredDetails?.children[0];
                // Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
                const orderType = rmdMatchingWithParent.attributes.nBuySell == 1 ? 'BUY' : rmdMatchingWithParent.attributes.nBuySell == 2 ? 'SELL' : '';
                if (!arrRecommendationsStatusTypes.includes(status?.toLowerCase())) {
                    arrRecommendationsStatusTypes.push(status?.toLowerCase());
                }

                if (!arrRecommendationsOrderTypes.includes(orderType?.toLowerCase()) && orderType) {
                    arrRecommendationsOrderTypes.push(orderType?.toLowerCase());
                }
                //BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : Start
                let strOrderType = '';
                if (rmdMatchingWithParent.attributes.nBuySell == 1) {
                    strOrderType = 'BUY';
                }
                else if (rmdMatchingWithParent.attributes.nBuySell == 2) {
                    strOrderType = 'SELL';
                }
                else if (rmdMatchingWithParent.attributes.nBuySell == 3) {
                    strOrderType = 'TRADE';
                }
                //BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : End
                // Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
                return {
                    id: each.ID,
                    touchLineId: getMktSegIdFromMappedMktSegId(each.nMarketSegmentId) + "_" + each.nToken + each.ID,
                    nMarketSegmentId: each.nMarketSegmentId,
                    nSegmentId: getMktSegIdFromMappedMktSegId(each.nMarketSegmentId),
                    quotienType: each.sScripDesc.split(" ")[each.sScripDesc.split(" ").length - 1],
                    companyName: each.sScripDesc.trim(" \" ").split(" ")[2],
                    entryDate: handleTime(each.LastModify, DATE_FORMAT.DATE_TIME),
                    expiryDate: handleTime(each.nExpiryDate, DATE_FORMAT.DATE),
                    exChangeName: each.sScripDesc.trim(" \" ").split(" ")[0],
                    // nBuySell: rmdMatchingWithParent.attributes.nBuySell == 1 ? 'BUY' : rmdMatchingWithParent.attributes.nBuySell == 2 ? 'SELL' : '',
                    nBuySell: strOrderType,
                    nRecoType: each.nRecoType,
                    EnteredPrice: rmdMatchingWithParent.attributes.EnteredPrice,
                    SLPrice: rmdMatchingWithParent.attributes.SLPrice,
                    SQPrice: rmdMatchingWithParent.attributes.SQPrice,
                    OrderCount: rmdMatchingWithParent.attributes.OrderCount,
                    nToken: each.nToken,
                    nTotalNoRecords: each.nTotalNoRecords,
                    sRecoDetails: modifiledChild,
                    sRecoId: each.sRecoId,
                    sRecoTag: each.sRecoTag,
                    sScripDesc: each.sScripDesc,
                    sLongShort: modifiledChild[0].sLongShort,
                    isScripExpired: formattedScripDate.length <= 0 ? false : dayjs(formattedScripDate, 'DD MMM YYYY').isBefore(dayjs().format('DD MMM YYYY')) ? true : false,
                    sSource: each.sSource,
                    dontMiss: each.dontMiss,
                    isHoldings: each.isHoldings,
                    ltp: 0,
                    nLtpChange: 0,
                    nLtpPercent: 0,
                    scripInfo: [],
                    calSLPrice: modifiledChild[0].calSLPrice,
                    calSQPrice: modifiledChild[0].calSQPrice,
                    positivePercent: modifiledChild[0].positivePercent,
                    negativePercent: modifiledChild[0].negativePercent,
                    status: status,//Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
                    sURL: sURL
                };
            });
            // const arrRecommendationWithActiveScrips = arrRecommendationData.filter((each) => (!each.isScripExpired && !each.status) || (each.isScripExpired && !each.status));
            return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: { recommendations: arrRecommendationData, tags: arrRecommendationTags, orderTypes: arrRecommendationsOrderTypes, statusTypes: arrRecommendationsStatusTypes } }; //Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
        } else {
            return { status: true, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: null };
        }

    } catch (error) {
        return { status: true, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}

function _recommendationsWithScripInfo(recommendations, arrScripInfo, dispatch) {
    if (recommendations?.length > 0 && arrScripInfo?.length > 0) {
        const recommendationsWithScripInfo = [];
        recommendations.forEach((each) => {
            const matchedScrip = arrScripInfo.find((eachScrip) => (eachScrip?.id === (each?.nMarketSegmentId + '-' + each?.nToken).toString()));
            if (matchedScrip && Object.keys(matchedScrip)?.length > 0) {
                recommendationsWithScripInfo.push({ ...each, scripInfo: convertScripResponseWatchlistGrid([matchedScrip])[0] });
            } else { }
        });
        const arrRecommendationTags = [];
        recommendationsWithScripInfo.forEach((each) => {
            if (each?.sRecoTag?.length > 0) {
                if (!arrRecommendationTags.includes(each?.sRecoTag?.toLowerCase())) {
                    arrRecommendationTags.push(each.sRecoTag?.toLowerCase());
                }
            } else { }
        });
        dispatch(recommendationTags(arrRecommendationTags));
        return [...recommendationsWithScripInfo];
    }
    else {
        return [];
    }
}

function _arrRecommendationsWithFilters(search, objRecommendationFiltersInputs, arrRecommendations, objLayOut, scripOverviewData) {


    if ((Object.keys(objRecommendationFiltersInputs)?.length > 0) && search?.length > 0) {

        const arrfilteredAndSearchRecommendations = arrRecommendations?.length && arrRecommendations?.filter((mainObject) =>
            Object.entries(objRecommendationFiltersInputs).every(
                ([key, value]) => mainObject[key]?.toLowerCase() === value?.toLowerCase()
            )
        ).filter((each) => each?.companyName.toLowerCase().includes(search?.toLowerCase()));
        return arrfilteredAndSearchRecommendations;
    }
    if ((Object.keys(objRecommendationFiltersInputs)?.length) && search?.length === 0) {

        const arrFilteredRecommendations = arrRecommendations?.length && arrRecommendations?.filter((mainObject) =>
            Object.entries(objRecommendationFiltersInputs).every(
                ([key, value]) => mainObject[key]?.toLowerCase() === value?.toLowerCase()
            )
        );
        return arrFilteredRecommendations;
    }
    if (search?.length > 0 && Object.keys(objRecommendationFiltersInputs)?.length === 0) {
        // Prachi T : 05-12-2023 : BT-107423 - Breeze - Dashboard recommemndations - Start

        const keywords = search?.toLowerCase()?.split(' ');

        const arrData = arrRecommendations?.length && arrRecommendations?.filter(data => {
            const scripData = (data?.scripInfo[WATCHLIST_GRID_INDEX?.DISPLAY_DESC] + data?.scripInfo[WATCHLIST_GRID_INDEX?.EXCHANGE] + data?.scripInfo[WATCHLIST_GRID_INDEX?.INSTRUMENT] + data?.scripInfo[WATCHLIST_GRID_INDEX?.OPTIONTYPE])?.toLowerCase()?.split(' ')?.join('');

            return keywords?.every(keyword => scripData?.includes(keyword));
        });

        return arrData;
        // Prachi T : 05-12-2023 : BT-107423 - Breeze - Dashboard recommemndations - End
    }

    return objLayOut?.sideOverview ? arrRecommendations?.filter((each) => (each?.nSegmentId + "_" + each?.nToken) === scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) : arrRecommendations;
}

export { _recommendation, _recommendationsWithScripInfo, _arrRecommendationsWithFilters };
